import { useEffect } from "react";
import { useLocationStore } from "./locationStore";

export function useLocationBootstrap() {
  const bootstrap = useLocationStore((s) => s.bootstrap);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);
}
